import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { isMobileOnly } from "react-device-detect";
import { Skeleton } from "@mui/material";
import { useHistory } from "react-router-dom";
import { Button, Col, Container, Row } from "react-bootstrap";
import axios from "axios";
import { base_url, postHeader } from "../../../../Helpers/request";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { FaCircleChevronRight, FaCircleChevronLeft } from "react-icons/fa6";

const BannerSlider = () => {
  const history = useHistory();
  const [banner, setBanner] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch banner data
    setLoading(true);
    axios
      .get(base_url + `/home/slider`, { headers: postHeader })
      .then((response) => {
        if (response.data.status === 1) {
          setLoading(false);
          setBanner(response.data.data);
          localStorage.setItem("bw-bannerdata", JSON.stringify(response.data.data));
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, []);

  const NextArrow = ({ onClick }) => (
    <div className="custom-arrow custom-next" onClick={onClick}>
      <FaCircleChevronRight />
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div className="custom-arrow custom-prev" onClick={onClick}>
      <FaCircleChevronLeft />
    </div>
  );

  console.log("banner", banner)

  // Slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          dots: false
        },
      },
    ],
  };
  return (
    <section className="banner_section">
      {!loading ? (
        <Slider {...settings}>
          {banner.map((val, index) => (
            <div key={index}>
              <div
                className="rcs_hero_slider"
                style={{
                  backgroundImage: `url(${isMobileOnly ? val.mobile_image : val.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Container fluid>
                  <Row className="rcs_hero_img">
                    <Col xs={10} md={11} xl={10} className="m-auto text-center text-md-left">
                      <h1 data-aos="fade-up-left" data-aos-duration="700">
                        {val.title}
                      </h1>
                      <p
                        data-aos="fade-up-left"
                        data-aos-duration="1200"
                        data-aos-delay="300"
                        className="mb-md-2"
                      >
                        {val.short_text}
                      </p>
                      {val.btn_text && (
                        <Link to={val.btn_link}>
                          <Button
                            data-aos="fade-up-left"
                            data-aos-duration="1800"
                            data-aos-delay="400"
                            // onClick={() => history.push("/" + val.btn_link)}
                            className="outline-base-btn large"
                          >
                            {val.btn_text}
                          </Button>
                        </Link>
                      )}
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          ))}
        </Slider>
      ) : (
        <div className="sk" style={{ margin: "0px" }}>
          <Skeleton variant="text" animation="wave" height={"90vh"} />
        </div>
      )}
    </section>
  );
};

export default BannerSlider;
